var borders_default = {
  "borderT": "bgyjX",
  "borderB": "_3Cp93",
  "borderL": "_3v4XS",
  "borderR": "SM3BM",
  "borderColorOverride": "iJu5D"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
